// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38pZB","toggleWrap":"styles_toggleWrap__2anUk","content":"styles_content__NGYlN","selectAreaCode":"styles_selectAreaCode__2jPIl"};